// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BPkJ","toggle":"styles_toggle__1J6Ok","preview":"styles_preview__3OPc0"};